import { useEffect, useState, type ReactNode } from "react";
import { msal, LOGIN_REQUEST, resolveAccount } from "./msal";

type Phase = "checking" | "signed-out" | "signed-in";

// Blocks the app until there is a signed-in Entra account (production), or
// immediately in dev builds (the vite proxy reaches the API locally). Styled
// inline so it carries no dependency on the app stylesheet.
export function AuthGate({ children }: { children: ReactNode }) {
  const [phase, setPhase] = useState<Phase>(
    import.meta.env.DEV ? "signed-in" : "checking",
  );

  useEffect(() => {
    if (import.meta.env.DEV) return;
    resolveAccount()
      .then((account) => setPhase(account ? "signed-in" : "signed-out"))
      .catch(() => setPhase("signed-out"));
  }, []);

  if (phase === "signed-in") return <>{children}</>;

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#0b0b0d",
        color: "#e8eaed",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 22, fontWeight: 700 }}>Virtual Seven Post Rig</div>
        <div style={{ fontSize: 13, color: "#7c8590", margin: "6px 0 20px" }}>
          Juncos Hollinger Racing · Engineering
        </div>
        {phase === "signed-out" && (
          <button
            onClick={() => void msal.loginRedirect(LOGIN_REQUEST)}
            style={{
              fontFamily: "ui-monospace, monospace",
              fontSize: 12,
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: "#03ff4f",
              background: "#131417",
              border: "1px solid #0a7d33",
              borderRadius: 3,
              padding: "12px 22px",
              cursor: "pointer",
            }}
          >
            Sign in with Microsoft
          </button>
        )}
      </div>
    </div>
  );
}
